import http from 'hub-http/clients/apiClient';
export const updateEngagementData = (engagementId, payload) => {
  return http.put(`/engagements/v2/engagements/${engagementId}`, {
    data: payload
  });
};